export const demographicsFieldsConfig = [
 {
    key: 'DOB',
    label: 'Date of Birth',
    required: true
  },
  {
    key: 'gender',
    label: 'Gender',
    required: true
  },
  {
    key: 'ethnicity',
    label: 'Ethnicity',
    required: true
  },
  {
    key: 'zip',
    label: 'Zip',
    required: false,
    length: 5
  },
  {
    key: 'email',
    label: 'Email',
    required: true,
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  },
  {
    key: 'dentalSchool',
    label: 'Dental school',
    required: true
  },
  
{
  key: 'otherSchool',
  label: 'Other school name',
},
  {
    key: 'yearGraduated',
    label: 'Year Graduated',
    required: true
  },
  {
    key: 'specialty',
    label: 'Specialty',
    required: true
  },
  {
    key: 'degree',
    label: 'Degree',
    required: true
  }
];

export const locationFieldsConfig = [
  { key: 'tin', label: 'TIN', required: true, length: 9 },
  { key: 'name', label: 'Location name', required: true },
  { key: 'address', label: 'Address', required: true, altKeys: ['address1'] },
  { key: 'city', label: 'City', required: true },
  { key: 'state', label: 'State', required: true, length: 2 },
  { key: 'zip', label: 'Zip', required: true, length: 5 },
  { key: 'isPrimary', label: 'Primary location', required: true },
  { key: 'startPracticingAt', label: 'Date started', required: true },
  { key: 'officeTypeID', label: 'Office type', required: true, altKeys: ['officeTypeId']  },
  {
    key: 'voicePhone',
    label: 'Location phone',
    required: true,
    pattern: /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/
  },
  { key: 'email', label: 'Email', required: true, altKeys: ['locationEmail'] },
  { key: 'endedPracticingAt', label: 'Date ended', required: true },
];